import { makeStyles, TextField, OutlinedTextFieldProps, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { Colors } from '../controls/helpers';
import HelpTooltip from '../controls/helpers/HelpTooltip';

export type WhiteTextFieldProps = OutlinedTextFieldProps & {
    dollarSignAdornment?: boolean;
    textColor?: string;
    tooltip?: string;
    labelColor?: string;
};

const WhiteTextField = (props: WhiteTextFieldProps) => {
    const { label, dollarSignAdornment, className, InputProps, textColor, tooltip, labelColor, ...rest } = props;
    const classes = useStyles(props);
    const combinedInputProps = dollarSignAdornment ? { ...InputProps, startAdornment: <>$</> } : InputProps;

    return <>
        {!!label &&
            <Typography className={classes.label}>
                {label}
                <HelpTooltip title={tooltip} />
            </Typography>
        }
        <TextField
            fullWidth
            label={null}
            inputProps={{ className: classes.input }}
            InputProps={{ ...combinedInputProps }}
            className={clsx(classes.textField, className)}
            {...rest}
            variant="outlined"
        />
    </>
};

const useStyles = makeStyles({
    label: (props: WhiteTextFieldProps) => ({
        color: props.labelColor ?? Colors.DarkGrey,
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center'
    }),
    textField: (props: WhiteTextFieldProps) => ({
        backgroundColor: Colors.White,
        marginRight: 12,
        marginBottom: 16,
        '& .MuiInputAdornment-positionStart .MuiTypography-root': {
            marginRight: -7,
            color: props.value ? (props.textColor ?? Colors.White) : Colors.DarkGrey
        }
    }),
    input: {
        mozAppearance: 'textfield',
        '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
        }
    }
}, { name: 'WhiteTextField' });

export default WhiteTextField;
